module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"deanab-dev","short_name":"deanab-dev","start_url":"/","background_color":"#1b1f22","theme_color":"#ffffff","display":"minimal-ui"},
    }]
